// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pPqY5IxuQOwN6RhT4MFb{align-items:center;display:flex}.azXvTB_hjQY0fwvllF0n{border-top-right-radius:0;border-bottom-right-radius:0;height:32px}.XJ0ThAqP5s7uX_ZTwEpo{border-top-right-radius:6px;border-bottom-right-radius:6px;width:24px}.XJ0ThAqP5s7uX_ZTwEpo.HzU7yFtOiYHfNZ655Qmh:before{background:var(--white-50)}.XJ0ThAqP5s7uX_ZTwEpo.GAolDIYTuMEkFV8J7M2w:before{background:0 0}.XJ0ThAqP5s7uX_ZTwEpo:before{content:"";background:var(--border-neutral-primary);width:1px;height:16px;position:absolute;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `pPqY5IxuQOwN6RhT4MFb`,
	"leftBtn": `azXvTB_hjQY0fwvllF0n`,
	"rightBtn": `XJ0ThAqP5s7uX_ZTwEpo`,
	"primary": `HzU7yFtOiYHfNZ655Qmh`,
	"loading": `GAolDIYTuMEkFV8J7M2w`
};
export default ___CSS_LOADER_EXPORT___;
